import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";
import CoreValuesProgram from "./index";
import { Award } from "lucide-react";

const coreValuesProgramRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Core Values Program",
		basePath: "core-values-program",
		mainComponent: <CoreValuesProgram />,
	    layout: "/console",	   
	    icon: <Award className="icon-item" />,
	    subTitle:"Core Values Program",
		level:1,
		moduleId: 0,
	})
]

export default coreValuesProgramRoutes;